import * as SummaryFlight from './components/DesktopSummaryFlight.css';
import * as Header from './components/Header/Header.css';
export default {
    SummaryFlight,
    Header
};
